iScreenWizard.controller('TrainingEnCertificeringController', function ($scope, $state, $mdDialog, Ajax, ErrorHandler, Dictionary, Certificaat, userService) {

    $scope.certificates = [];
    $scope.userService = userService;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    var refresh = function() {
        Certificaat.all().then(function (certificates) {
            $scope.certificates = certificates;
        });
    };
    $scope.refresh = refresh;

    $scope.viewCertificate = function(certificate, ev) {
        $mdDialog.show({
            controller: TrainingenEnCertificeringDialogController,
            locals: {
                certificate: certificate
            },
            templateUrl: '/info/trainingen-en-certificering/show',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true
        });
    };

    function TrainingenEnCertificeringDialogController($scope, certificate) {
        $scope.certificate = certificate;
    };

});